module.exports = __webpack_public_path__ + "img/eccbcba.svg";